import React from 'react';

import BlogPostEdit from '../../../components/Admin/BlogPosts/BlogPostEdit/BlogPostEdit.module';

function BlogPostEditView() {
  return (
    <BlogPostEdit />
  );
}

export default BlogPostEditView; 